module.exports = __webpack_public_path__ + "img/cart-delete-bg-hen.98221732.png";